import classes from "./SuccessNotification.module.css";
import CheckIcon from "../../images/deliveries/deliveriesModals/checkIcon.svg";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";

export function SuccessNotificationModal({ msg }) {
  const { t } = useTranslations();
  const modalText = t.deleteConfirmationMessage;

  return (
    <div className={`${classes.successNotification} fadeInTranslate`}>
      <img src={CheckIcon} />
      <div>
        <div className={classes.headDiv}>{modalText.headerText}</div>
        <div style={{ color: "var(--textDarkGrey)", lineHeight: "24px" }}>
          {msg}
        </div>
      </div>
    </div>
  );
}
